import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const usePageTitle = (translationKey: string, defaultTitle: string) => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = t(translationKey, {
      defaultValue: defaultTitle,
      PRODUCT_NAME: process.env.REACT_APP_PRODUCT,
    });
  }, [t, translationKey, defaultTitle]);
};
